// extracted by mini-css-extract-plugin
export default {"data_input":"styles_data_input__1Ug1V","data_symbol_img":"styles_data_symbol_img__xs+eV"};